import globalComponents from './global'
import navigationComponents from './navigation'
import externalContentComponents from '~/components/externalContent'

export default [
  ...globalComponents,
  ...navigationComponents,
  ...externalContentComponents,
]
